import { actionsAbstract, mutationsAbstract } from '@/store/abstract'
import { account as accountApi } from '@/backend/api'

const state = {
  referralsDetail: {},
  referralsCount: null,
  referralsList: [],
  retrieveLoader: false,
  createLoader: false,
  deleteLoader: false
}

const actions = {
  GET_PROGRAM: () => {
    return new Promise((resolve, reject) => {
      accountApi.getReferralProgram()
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  PATCH_BENEFICIARY: (context, payload) => {
    return new Promise((resolve, reject) => {
      accountApi.patchReferralBeneficiary(payload)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  ...actionsAbstract
}

export default {
  actions,
  mutations: mutationsAbstract,
  namespaced: true,
  state
}
